<template>
	<Accordion v-model:value="active">
		<accordion-panel v-for="(label,index) in labels " :value="index" :key="info[index]['titolo']">
			<AccordionHeader>{{ info[index]['titolo'] }}</AccordionHeader>
			<AccordionContent>
				<FormInput :dati='info[index]'
									 :formlabel="label"
									 :stilestruttura="style"
									 :action="action[index]"
									 :ref="'input_'+index">
				</FormInput>
				<div class="text-right">
					<button @click="salvaAccordion(index)" class="p-button p-component p-button-success">
						<span class="p-button-label">{{ bottone }}</span>
					</button>
				</div>
			</AccordionContent>
		</accordion-panel>
	</Accordion>
</template>

<script>
import FormInput from "./FormInput.vue";
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

export default {
	name: "AccordionForm",
	components: {
		FormInput,
		Accordion,
		AccordionPanel,
		AccordionHeader,
		AccordionContent
	},
	props: ['dati', 'strutture', 'azione', 'annulla', 'stilestruttura', 'id', 'bottone', 'titolo' ],
	data() {
		return {
			cancel: this.annulla,
			action: this.azione,
			info: JSON.parse(this.dati),
			labels: JSON.parse(this.strutture),
			style: this.stilestruttura,
			errors: {},
			imginput: false,
			idform: this.id,
			active : 0
		};
	},
	beforeMount() {
		if (typeof this.id == "undefined") {
			this.idform = 'maschera';
		} else {
			this.idform = this.id;
		}

	},
	mounted() {
		console.log('form adcordion')
	},
	methods: {
		salvaAccordion(index){
			const max_index = this.info.length - 1 ;
			if(max_index == this.active) {
				this.$refs['input_'+index].checkForm(0) //form finita uso il redirect
			}else{
				this.$refs['input_'+index].checkForm(2) //form non finita apro l'accordion successivo
				this.active = index + 1 ;
			}
		}
	}
}
</script>
